module.exports = __webpack_public_path__ + "static/media/Pattern_Sidebar.92f580c6.jpg";